// CRM 2.0 card ⋮ menu (M1-F11, row M1.28) — prototype .kebab / .menu. The items come
// from Crm2Page (menuFor); picking one calls onPick(item). Closes on an outside click.
import React, { useEffect, useRef, useState } from "react";
import css from "./Crm2Cards.module.css";

export default function CardMenu({ items, onPick }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [open]);
  if (!items?.length) return null;
  return (
    <span ref={ref}>
      <button type="button" className={css.kebab} aria-label="More actions" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        <svg viewBox="0 0 24 24" width="30" height="30" aria-hidden="true">
          <path fill="currentColor" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2" />
        </svg>
      </button>
      {open && (
        <div className={css.menu} role="menu">
          {items.map((m) => (
            <button
              key={m}
              type="button"
              role="menuitem"
              onClick={() => {
                setOpen(false);
                onPick(m);
              }}
            >
              {m}
            </button>
          ))}
        </div>
      )}
    </span>
  );
}
